import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {SIDEBAR_NAVIGATION_BUTTONS} from "../../../../../constants";
import SqftNavRadius from "./toolRadius/SqftNavRadius";
import SqftNav45Corner from "./toolCorner/SqftNav45Corner";
import {setSQFTMenuOpened} from "../../../../../../../actions/sqftMenuFunctions";
// import config from "../canvas/store/sqftConfig";
// import SqftStore from "../canvas/store/sqftStore";
// import EventManager from "../canvas/store/sqftEventManager";

const SqftNavCorners = (props) => {
  // other popups, modals and so on
  const {menuOpened} = props;
  const [activeCornersMenu, setActiveCornersMenu] = useState("");
  const expanded = menuOpened === SIDEBAR_NAVIGATION_BUTTONS.corners || menuOpened === SIDEBAR_NAVIGATION_BUTTONS.radius;
  const radiusButtonRef = React.createRef();
  const cornerButtonRef = React.createRef();

  useEffect(() => {
    if(menuOpened === SIDEBAR_NAVIGATION_BUTTONS.corners) {
      setActiveCornersMenu(SIDEBAR_NAVIGATION_BUTTONS.corners);
      cornerButtonRef.current.click();
    } else if(menuOpened === SIDEBAR_NAVIGATION_BUTTONS.radius) {
      setActiveCornersMenu(SIDEBAR_NAVIGATION_BUTTONS.radius);
      radiusButtonRef.current.click();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuOpened]);

  const handleButtonClick = function (e) {
    //e.preventDefault();
    //e.stopPropagation();
    //setSQFTMenuOpened(SIDEBAR_NAVIGATION_BUTTONS.corners);

    setActiveCornersMenu(e.target.dataset.href);
  };

  // elements.overlay.hide();

  //debugger; // eslint-disable-line no-debugger
  return (
    <div className={"content side-level2" + (expanded ? " expanded" : "")} data-content="radius" id="radius-overlay">
      <div className="content-inner">
        <div className="lightbox-title-block">
          <span className="h7" data-text="sqft.navigation.radius.title">Select Radius</span>
          <p data-text="sqft.navigation.radius.description">Select a radius and then click or touch the corner of shape
            you want to have that radius.</p>
        </div>
        <div className="lightbox-button-block">
          <div className="lightbox-cancel-button" data-text="sqft.navigation.overlay.closeButton">Close</div>
        </div>
        <div className="lightbox-scroll">
          <div className="lightbox-nav">
            <div className="lightbox-nav-cell">
              <button ref={radiusButtonRef} data-href="radius" className={"lightbox-nav-button " + (activeCornersMenu !== "radius"? "" : " lightbox-nav-button--active")} onClick={handleButtonClick}
                      data-text="sqft.navigation.radius.radiusTitle">Radius
              </button>
            </div>
            <div className="lightbox-nav-cell">
              <button ref={cornerButtonRef} data-href="corner" className={"lightbox-nav-button " + (activeCornersMenu !== "corner"? "" : " lightbox-nav-button--active")} onClick={handleButtonClick}>45°</button>
            </div>
          </div>
          <div className={"lightbox-options-wrapper" + (activeCornersMenu !== "corner"? "" : " lightbox-nav-content")} id="radius">
            <SqftNavRadius/>
          </div>
          <div className={"lightbox-options-wrapper" + (activeCornersMenu !== "radius"? "" : " lightbox-nav-content")} id="corner">
            <SqftNav45Corner/>
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  return {
    menuOpened
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavCorners);
